import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {Preload} from '../components'
import {Page} from '../components'
import {
    TransactionRecordTopFilter,
    TransactionRecordShowMoney,
    TransactionRecordList,
} from '../components/transactionrecord'
import '../styles/transactionrecord/TransactionRecordTopFilter.css';

class TransactionRecordPage extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
        };

        this.loadData = this.loadData.bind(this);
    }

    loadData(tranType, offset) {
        const {transactionRecord} = this.props;
        tranType = tranType ? tranType : transactionRecord.filterKey;

        this.setState({loading: true});
        axios.get(`/api/wallet/transaction_record`, {params: {tran_type: tranType, offset}}).then((response) => {
            if (response.data.code === 0) {
                let data = response.data.data;
                if (transactionRecord.has_more && offset) {
                    this.props.dispatch({
                        type: 'TRANSACTION_RECORD_LOAD_MORE',
                        payload: data
                    })
                } else {
                    this.props.dispatch({
                        type: 'TRANSACTION_RECORD_INIT',
                        payload: data
                    });
                }

                this.setState({loading: false});
            }
        });
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        const {initialized} = this.props.transactionRecord;
        const {loading} = this.state;

        if (!initialized) {
            return <Preload />
        }

        return (
            <Page parent={this}>
                <div className="transaction-record-page">
                    <div className="transaction-record-flexed">
                        <TransactionRecordTopFilter loadData={this.loadData}/>
                        <TransactionRecordShowMoney />
                    </div>
                    <TransactionRecordList loadData={this.loadData} loading={loading}/>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    transactionRecord: state.transactionRecord
}))(TransactionRecordPage)



// WEBPACK FOOTER //
// ./src/pages/TransactionRecordPage.js